export default "__VITE_ASSET__MiDoTXEa__"